/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginCommand
 */
export interface LoginCommand {
    /**
     * 
     * @type {string}
     * @memberof LoginCommand
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof LoginCommand
     */
    password: string;
}

export function LoginCommandFromJSON(json: any): LoginCommand {
    return LoginCommandFromJSONTyped(json, false);
}

export function LoginCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function LoginCommandToJSON(value?: LoginCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
    };
}

